import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-24">
        <div className="overline animate-pulse">Loading…</div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-24" data-testid="forbidden">
        <div className="overline mb-3">403</div>
        <h1 className="font-display text-4xl font-bold">Access restricted</h1>
        <p className="mt-3 text-zinc-600">This area requires a different role. You are signed in as <span className="font-mono">{user.role}</span>.</p>
      </div>
    );
  }
  return children;
}
